(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement"]) return;
  try {
    
function syncBogoBannerHeight() {
  const banner = document.querySelector('[data-bogo-ticker]');
  if (!banner || banner.dataset.heightObserved) return;
  banner.dataset.heightObserved = 'true';
  const section = banner.closest('.shopify-section');
  const update = () => section.style.setProperty('--bogo-height', banner.getBoundingClientRect().height + 'px');
  update();
  new ResizeObserver(update).observe(banner);
}
syncBogoBannerHeight();
document.addEventListener('shopify:section:load', syncBogoBannerHeight);

  } catch(e) { console.error(e); }
})();
})();
